import addressbook from '../data/modules/addressbook.json';
import addressbook_categories from '../data/modules/addressbook_categories.json';
import billing from '../data/modules/billing.json';
import documents from '../data/modules/documents.json';
import general from '../data/modules/general.json';
import guestlists from '../data/modules/guestlists.json';
import messaging from '../data/modules/messaging.json';
import picklists from '../data/modules/picklists.json';
import presets from '../data/modules/presets.json';
import seatplans from '../data/modules/seatplans.json';
import statistics from '../data/modules/statistics.json';
import tickets from '../data/modules/tickets.json';

class CompanyModule {

    constructor() {
        this.modules = _([
            addressbook,
            addressbook_categories,
            billing,
            documents,
            general,
            guestlists,
            messaging,
            picklists,
            presets,
            seatplans,
            statistics,
            tickets,
        ])
        // .map(module => {
        //     module.rights = _.keyBy(module.rights, 'identifier');
        //     return module;
        // })
            .keyBy('identifier')
            .value();
    }

    getModules(modules) {
        return _.pick(this.modules, modules)
    }
}

export default new CompanyModule;



// WEBPACK FOOTER //
// ./src/app/modules/users/factories/modules-service.js